import React from 'react';
import { Heading, Stack, Box } from '@chaser/components';
import PageContainer from '../../components/PageContainer/index';
import useFetch from '../../hooks/useFetch';
import AdminService from '../../services/admin-service';
import useUser from '../../hooks/useUser';
import { groupBy, getFeature } from '../../components/FeatureGate/util';
import useFeatureConfig from '../../components/FeatureGate/useFeatureConfig';

const FeatureTest = () => {
  const { data } = useFetch(AdminService.getOrganisations);
  const user = useUser();

  const features = useFeatureConfig();

  const element = Object.keys(features).map(name => {
    let f = features[name];
    if (!f) return null;
    const orgs = data.map(org => {
      return getFeature(features, name, user, org);
    });

    const segment = orgs.filter(o => o.enabled);
    const segmentSize = segment.length;
    const variants = groupBy(segment, o => o.variant);

    const variantCount = Object.fromEntries(
      Object.entries(variants).map(([k, v]) => [k, v.length]),
    );

    return (
      <>
        <Heading fontSize="heading.2">{name}</Heading>
        <table style={{ fontSize: 13 }}>
          <tbody>
            {f.beta && (
              <tr>
                <td>beta</td>
                <td>true</td>
              </tr>
            )}
            {f?.segment?.organisation?.sample && (
              <tr>
                <td>org sample</td>
                <td>{f.segment.organisation.sample}</td>
              </tr>
            )}
            <tr>
              <td>sampled count &nbsp;&nbsp;</td>
              <td>{segmentSize}</td>
            </tr>
          </tbody>
        </table>
        <br />
        <div style={{ display: 'flex', flexWrap: 'nowrap' }}>
          {orgs.map(o => (
            <div
              style={{
                height: 60,
                width: 1,
                flexGrow: 1,
                background: o.enabled
                  ? `linear-gradient(to bottom, ${{ A: 'red', B: 'blue' }[o.variant] ??
                      o.variant ??
                      'blue'} 50%, ${o.canAccess ? 'green' : '#f8f8f8'} 50%)`
                  : '#f8f8f8',
              }}
            />
          ))}
        </div>
        {Object.keys(variantCount).length > 1 && <pre>{JSON.stringify(variantCount, null, 2)}</pre>}
        <hr style={{ margin: '50px 0' }} />
      </>
    );
  });

  return (
    <Box py="medium">
      <PageContainer>
        <Stack gap="xsmall">{element}</Stack>
      </PageContainer>
    </Box>
  );
};

export default FeatureTest;
